import React from 'react';
import { ArrowUpRight, ChevronLeft, ChevronRight } from 'lucide-react';
import icon1 from '../../assets/img/ServiceHiring/1.png';
import icon2 from '../../assets/img/ServiceHiring/2.png';

const ServiceHiring = () => {
  const hiringSteps = [
    {
      step: "STEP 1",
      title: "Discuss & Plan Requirements",
      desc: "engage clients to clarify the project’s vision & goals through brainstorming sessions.",
      icon: icon1
    },
    {
      step: "STEP 1",
      title: "Shortlist architecture",
      desc: "Assess & evaluate potential developers based on the requirements discussed in initial planning to create a qualified shortlist.",
      icon: icon2
    }
  ];

  return (
    <section className="service-hiring">
      <div className="hiring-content">
        <h2 className="hiring-title">
          <span className="text-primary">Hiring Simplified: Connect With Architecture For</span> Your BIM Modeling And CAD Solutions
        </h2>
        
        <p className="hiring-subtitle">
          Chudasama Outsourcing’ strategic planning and easy-to-hire models simplify bim modeler and CAD Draftsman. 
          Here is our seamless process for hiring offshore architectures for your bim solutions.
        </p>

        <div className="hiring-btn-container" style={{ marginBottom: '40px' }}>
          <button className="hiring-btn">
            Share Your Team <ArrowUpRight size={22} />
          </button>
        </div>

        <div className="hiring-timeline-container" style={{ position: 'relative' }}>
          <ChevronLeft className="timeline-nav-icon nav-left" size={32} />
          
          <div className="hiring-timeline-wrapper">
             <div className="hiring-timeline-line-base">
                <div className="hiring-timeline-line-active" style={{ width: '40%' }}></div>
             </div>
             
             {hiringSteps.map((item, index) => (
                <div key={index} className="hiring-step">
                   <p className="step-label">{item.step}</p>
                   <div className="step-icon-wrapper" style={{ boxShadow: index === 0 ? '0 0 25px rgba(84, 178, 72, 0.5)' : 'none' }}>
                      <img src={item.icon.src || item.icon} alt={item.title} />
                   </div>
                   <div className="step-info">
                      <h4 className="step-title">{item.title}</h4>
                      <p className="step-desc">{item.desc}</p>
                   </div>
                </div>
             ))}
          </div>

          <ChevronRight className="timeline-nav-icon nav-right" size={32} />
        </div>
      </div>
    </section>
  );
};

export default ServiceHiring;
